'use strict';

const h = require('phy');
const { getOptionBhcTag } = require('../util/bloodhound');

module.exports = ({
  bhc,
  className,
  disabled,
  optionId,
  optionText,
  selected,
  traitId,
  value,
}) =>
  h(
    'option',
    {
      class: className,
      disabled,
      'data-bhc': bhc || getOptionBhcTag(value),
      id: `trait-${traitId}-${optionId}`,
      key: `trait-${traitId}-${optionId}`,
      label: optionText,
      selected,
      value,
    },
    optionText
  );
